export default "__VITE_ASSET__BZvGIRQX__"